import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import { GetAssessmentQuestionConfigsAPIResponse } from 'types';

const baseUrl = `${API_ENDPOINT}/assessment-question-config`;

export const getAssessmentQuestionConfig = async (
	assessmentTemplateId: string,
	difficulty: number,
	tagRelationshipIds: string[],
): Promise<GetAssessmentQuestionConfigsAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}`, {
		assessmentTemplateId,
		difficulty,
		tagRelationshipIds,
	});
	return response.data;
};

